import NavBarWizardBaseCtrl from './NavBarWizardBaseCtrl';

export default function () {
    return {
        restrict: 'A',
        controller: NavBarWizardBaseCtrl
    };
}
